import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Services from './components/Services'
import Portfolio from './components/Portfolio'
import About from './components/About'
import Contact from './components/Contact'
import LatestBlog from './components/LatestBlog'
import Footer from './components/Footer'
import ChatWidget from './components/ChatWidget'

export default function MainSite() {
  return (
    <div className="min-h-screen bg-background text-text-main font-body">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Portfolio />
        <About />
        <Contact />
        <LatestBlog />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  )
}
